(ns minorodata.components.pipeline-editor.extract
  (:require
   ["@xyflow/react" :refer [ReactFlowProvider]]
   ["allotment" :refer [Allotment]]
   ["react" :as react]
   [applied-science.js-interop :as jsi]
   [goog.functions :refer [debounce]]
   [minorodata.app.handlers :refer [dispatch]]
   [minorodata.components.pipeline-editor.details.core :refer [details]]
   [minorodata.components.pipeline-editor.dag :refer [subdag]]
   [re-posh.core :as re-posh]
   [ui.drawer]))

(defn fetch-extract-dag [dag-id filters]
  (dispatch [:pipeline-editor.events/set-dag-filter {:params (merge {:id dag-id} filters)}]))

(defn dag [{:keys [dag-data extract]}]
  (let [{:keys [master-id]} extract]
    [:div {:class "h-full"}
     [:f> subdag {:id            master-id
                  :dag-data      dag-data
                  :apply-filters #(fetch-extract-dag (:id dag-data) %)}]]))

(defn extract-page' [{:keys [master-id extract-data selected dag-data panel-state]}]
  (let [panel-ref (react/useRef nil)
        initial-sizes (react/useMemo (fn [] (js->clj (:sizes panel-state))) #js [])]

    (react/useEffect
     (fn []
       (jsi/call-in panel-ref [:current :resize] (clj->js (cond-> (:sizes panel-state)
                                                            (= 3 (count (:sizes panel-state)))
                                                            next)))
       js/undefined)
     #js [(:sizes panel-state)])

    [:> Allotment {:ref      panel-ref
                   :vertical true
                   :default-sizes (cond-> initial-sizes
                                    (= 3 (count initial-sizes))
                                    next)
                   :on-change     (debounce #(let [sizes (js->clj %)
                                                   sizes (cond-> sizes
                                                           (= 3 (count sizes))
                                                           next)]
                                               (when (not= sizes (:sizes panel-state))
                                                 (dispatch [:pipeline-editor.events/set-panel-sizes sizes])))
                                            200)}
     [:> Allotment.Pane {:min-size       150
                         :preferred-size "50%"
                         :snap           true
                         :class "relative"}
      [dag {:dag-data dag-data
            :extract  extract-data}]]
     [:> Allotment.Pane {:min-size       200
                         :preferred-size "50%"
                         :snap           true}
      [details {:selected selected}]]]))

(defn extract-page [{:keys [master-id group-id] :as props}]
  (let [panel-state  @(re-posh/subscribe [:pipeline-editor.subs/panel])
        extract-data @(re-posh/subscribe [:pipeline-editor.subs/extract master-id])
        sandbox?     @(re-posh/subscribe [:sandbox.subs/enabled?])
        dag-data     @(re-posh/subscribe [:pipeline-editor.subs/dag master-id :extract sandbox?])
        query        @(re-posh/subscribe [:app-route/prop :app-route/query])]

    [:> ReactFlowProvider
     [:f> extract-page' (assoc props
                               :panel-state  panel-state
                               :extract-data extract-data
                               :dag-data           dag-data
                               :selected           (if (:tab-preview-type query)
                                                     {:type (:tab-preview-type query)
                                                      :id   (:tab-preview-id query)
                                                      :group-id (:tab-preview-group-id query)
                                                      :preview true}
                                                     {:type "extract"
                                                      :id master-id
                                                      :group-id group-id}))]]))